<div class="atn-ds-stepper">
  <ng-content></ng-content>
</div>
